<!--accessibility-->
<div id="skiptocontent" [tabIndex]="globalConfigurationService.getAddIndexToSkiptocontent()?null:1" [ngStyle]="{visibility:isAllowedSkipNavigation?'':'hidden'}"><a href="#maincontent" id="skiptocontent_link" tabindex="0" (click)="navigateToAnchor($event)">{{'generic.accessibility_goto_main' | translate}}</a></div>
<!-- PROGRESS BAR -->
<!-- <fuse-progress-bar></fuse-progress-bar> -->
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
@if (layoutConfig.layout.style === 'vertical-layout-1') {
  <vertical-layout-1 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-1>
}
<!-- / VERTICAL LAYOUT 1 -->

<!-- VERTICAL LAYOUT 2 -->
@if (layoutConfig.layout.style === 'vertical-layout-2') {
  <vertical-layout-2 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-2>
}
<!-- / VERTICAL LAYOUT 2 -->

<!-- VERTICAL LAYOUT 3 -->
@if (layoutConfig.layout.style === 'vertical-layout-3') {
  <vertical-layout-3 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-3>
}
<!-- / VERTICAL LAYOUT 3 -->

<!-- HORIZONTAL LAYOUT 1 -->
@if (layoutConfig.layout.style === 'horizontal-layout-1') {
  <horizontal-layout-1 ngClass="{{ brand }}" class="{{ themeColor }}"></horizontal-layout-1>
}
<!-- / HORIZONTAL LAYOUT 1 -->

@if (isSnackbarRecallButtonConfigActive) {
  <app-snackbar-recall-button></app-snackbar-recall-button>
}